import colors from '@/assets/styles/main.scss';

export default function({}, inject) {
  // Inject to context as $colors
  inject('colors', colors);
}
